import React, { useState, useEffect, useRef } from "react";
import { RemoveRedEye } from "@mui/icons-material";
import * as Mui from "@mui/material";
import {
  themes,
  scrollTop,
  optionalAvathar,
  tableRowSx,
} from "services/constants";
import { useFetch } from "services/hooks/useFetch";
import { useSelector } from "react-redux";
import { Loader } from "components/Loader";
import { teamZoneLoanHistory } from "../Headers";
import { InfoMessage } from "components/CustomComponents/CustomButton";

const keys = [
  "applied_date",
  "department_name",
  "user_name",
  "principal_amount",
  "tenure_months",
  "interest_rate",
  "monthly_installment",
  "loan_type",
  "interest_type",
  "status",
];

export const Approve = ({
  departmentId,
  departmentChange,
  setDepartmentChange,
  loanScreen,
  setViewLoanDetails,
  userChange,
  setUserChange,
  setShowApprove,
  userId,
}) => {
  const { domain, userDetails, globalSearchValue, topbarCompanyId } =
    useSelector((state) => state.tokenReducer);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [loanData, setLoanData] = useState([]);
  const [updateData, setUpdateData] = useState(true);
  const containerRef = useRef(null);

  const {
    result: loanDetails,
    loading,
    setLoad: reCallApi,
  } = useFetch(
    `${domain}loans/?user_id=${userDetails.id}&status=Pending&department_id=${departmentId}&selected_user_id=${userId}&company_id=${topbarCompanyId}`
  );

  useEffect(() => {
    if (topbarCompanyId) {
      reCallApi(true);
    }
  }, [reCallApi, topbarCompanyId]);

  useEffect(() => {
    if ((departmentChange || userChange) && loanScreen === "Approve") {
      reCallApi(true);
      setUserChange(false);
      setDepartmentChange(false);
    }
  }, [
    departmentChange,
    loanScreen,
    reCallApi,
    setDepartmentChange,
    setUserChange,
    userChange,
  ]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    if (updateData && loanDetails?.length !== 0 && loanDetails) {
      setLoanData(loanDetails);
      setUpdateData(false);
    }
  }, [loanDetails, updateData]);

  useEffect(() => {
    if (loanDetails?.length !== 0 || loanDetails?.length === 0) {
      const filteredResults = loanDetails?.filter((item) =>
        keys.some((key) =>
          item[key]
            ?.toString()
            .toLowerCase()
            .includes(globalSearchValue.toString().toLowerCase())
        )
      );
      setLoanData(filteredResults);
      setPage(globalSearchValue ? 0 : page);
    }
  }, [globalSearchValue, loanDetails, page]);

  useEffect(() => {
    scrollTop(containerRef);
  }, [page]);

  return loading ? (
    <Loader info="Loading..." />
  ) : (
    <React.Fragment>
      <Mui.Grid container>
        <Mui.TableContainer
          ref={containerRef}
          sx={{ width: "100%", maxHeight: 724, mt: 2, ml: 2, mr: 2 }}
        >
          <Mui.Table className="border">
            <Mui.TableHead
              sx={{
                backgroundColor: themes.primary,
                position: "sticky",
                top: -1,
                zIndex: 10,
              }}
            >
              <Mui.TableRow sx={tableRowSx}>
                {teamZoneLoanHistory.map((head) => (
                  <Mui.TableCell>
                    <Mui.Typography fontWeight="bold">
                      {head.name}
                    </Mui.Typography>
                  </Mui.TableCell>
                ))}
              </Mui.TableRow>
            </Mui.TableHead>

            <Mui.TableBody>
              {loanData.length === 0 ? (
                <InfoMessage dataLength={loanDetails} />
              ) : (
                loanData
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item, index) => (
                    <Mui.TableRow sx={tableRowSx}>
                      {teamZoneLoanHistory.map((head) =>
                        head.name !== "Action" ? (
                          <Mui.TableCell>
                            {head.name === "Employee Name" ? (
                              <Mui.Stack direction="Row">
                                <Mui.Avatar
                                  sx={{ width: 23, height: 23 }}
                                  alt={item?.user_name?.charAt(0).toUpperCase()}
                                  src={item?.image_url ?? optionalAvathar}
                                />
                                &nbsp;
                                {item?.user_name}
                              </Mui.Stack>
                            ) : item[head.key] ? (
                              item[head.key]
                            ) : (
                              "N/A"
                            )}
                          </Mui.TableCell>
                        ) : (
                          <Mui.TableCell>
                            <Mui.IconButton
                              onClick={(e) => {
                                // handleMenuOpen(e, index);
                                setShowApprove(true);
                                setViewLoanDetails(item);
                              }}
                            >
                              <RemoveRedEye
                                sx={{ color: themes.headLine, strokeWidth: 2 }}
                              />
                            </Mui.IconButton>
                            {/* <Mui.Menu
                              anchorEl={anchorEl}
                              open={Boolean(anchorEl)}
                              onClose={handleMenuClose}
                              elevation={1}
                              transformOrigin={{
                                horizontal: "right",
                                vertical: "top",
                              }}
                              anchorOrigin={{
                                horizontal: "right",
                                vertical: "bottom",
                              }}
                            >
                              <Mui.MenuItem
                                onClick={() => {
                                  setShowApprove(true);
                                }}
                              >
                                View
                              </Mui.MenuItem>
                            </Mui.Menu> */}
                          </Mui.TableCell>
                        )
                      )}
                    </Mui.TableRow>
                  ))
              )}
            </Mui.TableBody>
          </Mui.Table>
        </Mui.TableContainer>
      </Mui.Grid>
      {loanData.length > 25 && (
        <Mui.TablePagination
          className="custom-pagination"
          rowsPerPageOptions={[25, 50, 75, 100]}
          component="div"
          count={loanData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}
    </React.Fragment>
  );
};
